function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.71 219.06c-.98 2.03-5.21 2.02-9.45 0-4.24-2.03-6.87-5.37-5.89-7.36.99-2 5.22-2.03 9.46 0 4.24 2.03 6.87 5.3 5.88 7.36z",
  fill: "#A400A0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.84 256.84l-.08-.06.08.06zM95.75 257.14z",
  fill: "#A10094"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.87 141.25c20 20.24 57.17 7.12 66.77-19.98 4.86-13.8-9.66-32.76-4.24-53.35 3.6-13.7 28.78-14.12 47.1-12.87a91.93 91.93 0 00-13.14-4.3c-2.52-.63-5.1-1-7.7-1.1-48.1-6.3-60.34 28.47-46.73 51.28 15.07 25.3-13.4 42.04-32.46 32.84-19.94-9.63 15.47-41.71 2.21-45.78a7.36 7.36 0 00-1.8-.3c-12.5 17.57-26.14 37.2-10 53.56z",
  fill: "#8A0072"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.52 126.1c.88-1.3 1.56-2.74 2-4.25.47-1.5.76-3.04.84-4.6.17-3.08-.27-6.16-1.31-9.06-.5-1.45-1.1-2.87-1.8-4.24l-2.13-4.23a84.32 84.32 0 01-4.1-8.72c-.6-1.61-1-3.3-1.16-5.01-.13-1.7-.08-3.4.16-5.09.2-1.65.5-3.25.82-4.82.33-1.57.7-3.17 1.17-4.76.9-3.25 2.34-6.33 4.25-9.12a28.51 28.51 0 017.27-7.07 47.93 47.93 0 018.76-4.6c1.52-.64 3.07-1.2 4.65-1.68 1.59-.46 3.2-.82 4.84-1.08 6.44-1 13-1.03 19.44-.07a85.3 85.3 0 0118.64 4.76 71.2 71.2 0 0116.82 9.03 87.77 87.77 0 00-17.47-7.2 95.32 95.32 0 00-18.4-3.57 66.63 66.63 0 00-18.4.68c-1.48.32-2.96.66-4.4 1.1-1.45.46-2.88.99-4.27 1.59a45.16 45.16 0 00-8.02 4.28 24.53 24.53 0 00-6.35 6.04 28.16 28.16 0 00-3.84 8 58.28 58.28 0 00-1.22 4.43c-.36 1.5-.69 3.02-.92 4.52-.54 2.88-.37 5.85.5 8.66.92 2.85 2.29 5.72 3.52 8.63l1.84 4.4c.64 1.49 1.17 3.03 1.6 4.6.84 3.17 1.02 6.48.53 9.73a17.37 17.37 0 01-3.86 8.72z",
  fill: "#74005D"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M140.07 224.89c16.69-18.78-4.72-49.3-8.7-53.83-1.97-2.24-3.57-2.85-4.69-2.9.61.18 1.14.56 1.48 1.1 24.06 35.03 7.17 52.42-6.53 63-13.7 10.57-1.84 15.3-.51 14.42-4.11-3.12 4.16-5.12 18.95-21.8zM19.21 216.2c11.23 2.34 33.68-34.36 41.9-42.03a41.39 41.39 0 0010.83-15.83S45.8 178.5 36.07 191.36c-9.73 12.86-15.82 15.78-21.58 8.28-3.68-4.8-8.49-2.36-11.52 2.13 3.23 6.31 7.78 12.68 16.24 14.44zM81.6 177.82c3.28-7.68-.36-7.83-.92-7.8.35.4.07 1.6-.99 3.78-7.8 16.14-13.11 41.68-13.8 57.72-.58 13 12.17 18.66 15.84 6.08-22.36-3.27-3.78-51.26-.13-59.78zM93.84 256.84l-.08-.05c-6.44-3.29 7.22-28.52 12.69-40.27 6.04-13-.17-39.28-.92-44.63-.53-3.82-1.84-4.26-2.56-4.2.15.34.22.7.2 1.07.13 9.43 5.9 28.75-1.72 48.34-8.38 21.6-19.31 42.78-12.51 44.15 1.6.33 3.99-1.23 6.8-4.15-.56.05-1.11 0-1.63-.19a2.47 2.47 0 01-.27-.07zM230.96 148.46c-2.15-6.16-5.33-6.3-8.28-4.95-2.16.98-3.5 3.33-3.68 8.1 2.34-4.75 5.73-.4 6.87.15 1.46.7 3.34 10.03-8.83 28.69-12.17 18.65-66.57-2.38-65.74-1.3.4.5.84.94 1.35 1.32 6.25 4.7 10.32 5.7 26.26 10.29 59.22 17 54.2-36.15 52.05-42.3z",
  fill: "#8A0072"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.32 180.22c10.81 23.21 6.64 54.07-31.2 66.43-4.09-3.12 3.13-6.04 17.94-22.72 16.69-18.78-3.68-48.36-7.7-52.9-1.96-2.24-3.56-2.84-4.68-2.9-2.06-.82-5.58-.16-3 16.36 3.52 22.47-15.94 60.1-27.93 72.66a4.1 4.1 0 01-1.63-.18l-.28-.12-.08-.06c-6.44-3.28 6.34-28.94 11.8-40.7 6.05-13 .72-38.84 0-44.19-.53-3.83-1.83-4.26-2.55-4.2-2.23-4.29-22.65 32.45-20.51 57.94.45 4 .18 8.05-.8 11.96-23.27 2.28-5.05-51.11-1.4-59.63 3.28-7.68.96-7.98.39-7.95-2.22-2.59-30.16 27.59-46.65 44.95-19.06 20.06-34.38 3.3-34.03-4.72a17.08 17.08 0 012.95-8.46c3.24 6.3 8.77 11.04 18.73 9.4 11.3-1.9 30.3-29.78 38.53-37.45 4.8-4.38 8.78-9.6 11.72-15.4 0 0-34.95 5.8-50.34-15.68-14.71-20.55 5.88-55.5 19.32-54.96-12.5 17.56-23 33.87-6.86 50.23 20 20.23 47.1 10.11 56.7-17.03 4.86-13.8-5.52-32.45-.11-53.05 3.6-13.7 31.55-14.07 49.88-12.78 29.13 12.09 47.12 38.21 25.23 66.55-7.16 9.28-14.23 12.17-17.38 18.7-4.25 14.56 4.41 23.64 35.16 33.12 31.99 9.88 36.84-5.94 35.77-15.29a44.48 44.48 0 01-.32-6.57c2.34-4.73 5.92-2.95 6.96-2.23 2.68 1.84 6.36 13.87-5.81 32.52-12.17 18.65-68.37-2.44-68.37-2.44l.55.79z",
  fill: "#A10094"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.42 66.58a14.72 14.72 0 11-10.8 27.38 14.72 14.72 0 0110.8-27.38z",
  fill: "#8A0072"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.52 64.17a14.72 14.72 0 11-10.8 27.38 14.72 14.72 0 0110.8-27.38z",
  fill: "#A51888"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.6 68.47a10.12 10.12 0 11-7.46 18.8 10.12 10.12 0 017.46-18.8z",
  fill: "#fff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.53 76.9a3.33 3.33 0 11-2.43 6.2 3.33 3.33 0 012.43-6.2z",
  fill: "#000"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176 106.18a14.72 14.72 0 11-27.06-11.6 14.72 14.72 0 0127.07 11.6z",
  fill: "#8A0072"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M181.11 103.71a14.72 14.72 0 11-27.06-11.58 14.72 14.72 0 0127.06 11.58z",
  fill: "#A51888"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.85 102.65a10.12 10.12 0 11-18.58-8.05 10.12 10.12 0 0118.58 8.05z",
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M168.51 99.32a3.33 3.33 0 11-6.12-2.62 3.33 3.33 0 016.12 2.62zM137.94 126.87a4.97 4.97 0 11-8.95-4.33 4.97 4.97 0 018.95 4.33z",
  fill: "#000"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M138.8 59.82s-32.35-1.99-37.12 3.36c-4.76 5.34 20.84 12.25 36.2 9.84 15.35-2.41 12.38-10.94.92-13.2zM18.69 124.98s.19 14.25 12.6 22.9c12.4 8.64 36.03 9.67 37.8 8.28 1.76-1.4.41-2.68-2.36-2.91-2.76-.23-20.31.55-35.87-12.03-8.92-7.2-9.87-23.76-12.17-16.24zM119.67 190.88c.58 5.08-2.15 25.53-9.9 37.8-7.74 12.27 3.15-16.56 2.63-22.76-1.39-16.7-2.76-32.64-.92-35.01 1.84-2.38 5.2-6.23 8.2 19.97zM144.25 144.61s-4.19 7.9 8.07 17.84c12.25 9.96 42.04 15.93 42.04 15.93s-17.63 2.3-30.71-2.91c-13.08-5.22-30.09-12.17-19.4-30.86z",
  fill: "#A400A0"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.94 158.34c-4.77 4.5-9.58 8.9-14.36 13.32-2.36 2.24-4.77 4.43-7.1 6.69-2.33 2.26-4.68 4.49-6.92 6.81a94.38 94.38 0 00-7.9 8.99c-.46.6-.98 1.34-1.5 2a32.07 32.07 0 01-3.45 3.67 20.88 20.88 0 01-4.14 3.04 11.8 11.8 0 01-5 1.5 7.36 7.36 0 01-4.95-1.57 10.5 10.5 0 01-3.26-4.42c3.57 4 6.6 4.8 8.07 4.55 1.49-.25 2.9-.84 4.14-1.72a20.68 20.68 0 003.53-3.02 39.76 39.76 0 004.36-5.65c.43-.69.96-1.38 1.47-2.05 2.04-2.6 4.23-5.1 6.55-7.47 4.63-4.66 9.51-9.06 14.63-13.18a179.1 179.1 0 0115.83-11.49zM25.3 127.36a4.35 4.35 0 11-7.82-3.79 4.35 4.35 0 017.83 3.79zM29.51 140.45a4.33 4.33 0 11-7.8-3.8 4.33 4.33 0 017.8 3.8zM40.06 150.36a4.33 4.33 0 11-7.8-3.78 4.33 4.33 0 017.8 3.78zM57.17 155.95a4.33 4.33 0 11-7.8-3.79 4.33 4.33 0 017.8 3.8z",
  fill: "#74005D"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.28 149.34a1.37 1.37 0 01-2.46-1.19 1.37 1.37 0 012.46 1.19zM26.43 138.33a1.36 1.36 0 11-2.43-1.21 1.36 1.36 0 012.43 1.21zM22.52 125.74a1.37 1.37 0 01-1.3.75 1.36 1.36 0 111.3-.75zM54.6 154.27a1.36 1.36 0 11-2.44-1.22 1.36 1.36 0 012.43 1.22z",
  fill: "#A400A0"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.1 185.08a4.34 4.34 0 01-7.98-.47 4.33 4.33 0 117.99.47z",
  fill: "#74005D"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.53 183.4a1.37 1.37 0 01-2.04.47 1.35 1.35 0 01-.5-1.42 1.36 1.36 0 112.54.95z",
  fill: "#A400A0"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.63 188.83a4.34 4.34 0 11-7.82-3.77 4.34 4.34 0 017.82 3.77z",
  fill: "#74005D"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M188.06 187.15a1.35 1.35 0 01-1.3.75 1.36 1.36 0 111.3-.75z",
  fill: "#A400A0"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M203.3 190.62a4.33 4.33 0 11-7.79-3.79 4.33 4.33 0 017.8 3.79z",
  fill: "#74005D"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M200.7 188.94a1.37 1.37 0 01-2.04.47 1.36 1.36 0 112.04-.47z",
  fill: "#A400A0"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M215.93 188.3a4.35 4.35 0 11-7.83-3.8 4.35 4.35 0 017.83 3.8z",
  fill: "#74005D"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M213.36 186.6a1.38 1.38 0 01-2.06.48 1.37 1.37 0 112.06-.48z",
  fill: "#A400A0"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.47 6.84c-.05-.53.65-.76.93-.3l3.59 6.04c.18.3.6.33.81.07l4.5-5.41c.34-.41 1-.07.86.44l-1.73 6.81a.5.5 0 00.53.63l7-.65c.53-.05.76.65.3.93l-6.04 3.59a.5.5 0 00-.06.81l5.4 4.5c.42.34.08 1-.44.86l-6.8-1.73a.5.5 0 00-.63.53l.65 7c.05.53-.66.76-.93.3l-3.6-6.04a.5.5 0 00-.8-.06l-4.5 5.4c-.34.42-1 .08-.87-.44l1.73-6.8a.5.5 0 00-.53-.63l-7 .65c-.53.05-.76-.66-.3-.93l6.04-3.6a.5.5 0 00.07-.8l-5.41-4.5c-.41-.34-.07-1 .44-.87l6.81 1.73a.5.5 0 00.63-.53l-.65-7zM186.47 35.84c-.05-.53.65-.76.93-.3l3.59 6.04c.18.3.6.33.81.07l4.5-5.41c.34-.41 1-.07.86.44l-1.73 6.81a.5.5 0 00.53.63l7-.65c.53-.05.76.65.3.93l-6.04 3.59a.5.5 0 00-.06.81l5.4 4.5c.42.34.08 1-.44.87l-6.8-1.74a.5.5 0 00-.63.53l.65 7c.05.53-.66.76-.93.3l-3.6-6.04a.5.5 0 00-.8-.06l-4.5 5.4c-.34.42-1 .08-.87-.44l1.73-6.8a.5.5 0 00-.53-.63l-7 .65c-.53.05-.76-.66-.3-.93l6.04-3.6a.5.5 0 00.07-.8l-5.41-4.5c-.41-.34-.08-1 .44-.87l6.81 1.73a.5.5 0 00.63-.53l-.65-7zM143.47 55.84c-.05-.53.65-.76.93-.3l3.59 6.04c.18.3.6.33.81.07l4.5-5.41c.34-.41 1-.07.86.44l-1.73 6.81a.5.5 0 00.53.63l7-.65c.53-.05.76.65.3.93l-6.04 3.59a.5.5 0 00-.06.81l5.4 4.5c.42.34.08 1-.44.87l-6.8-1.74a.5.5 0 00-.63.53l.65 7c.05.53-.66.76-.93.3l-3.6-6.04a.5.5 0 00-.8-.06l-4.5 5.4c-.34.42-1 .08-.87-.44l1.73-6.8a.5.5 0 00-.53-.63l-7 .65c-.53.05-.76-.66-.3-.93l6.04-3.6a.5.5 0 00.07-.8l-5.41-4.5c-.41-.34-.08-1 .44-.87l6.81 1.73a.5.5 0 00.63-.53l-.65-7zM80.47 29.84c-.05-.53.65-.76.93-.3l3.59 6.04c.18.3.6.33.81.07l4.5-5.41c.34-.41 1-.07.87.44l-1.74 6.81a.5.5 0 00.53.63l7-.65c.53-.05.76.65.3.93l-6.04 3.59a.5.5 0 00-.06.81l5.4 4.5c.42.34.08 1-.44.87l-6.8-1.74a.5.5 0 00-.63.53l.65 7c.05.53-.66.76-.93.3l-3.6-6.04a.5.5 0 00-.8-.06l-4.5 5.4c-.34.42-1 .08-.87-.44l1.73-6.8a.5.5 0 00-.53-.63l-7 .65c-.53.05-.76-.66-.3-.93l6.04-3.6a.5.5 0 00.07-.8l-5.41-4.5c-.41-.34-.07-1 .44-.87l6.81 1.73a.5.5 0 00.63-.53l-.65-7z",
  fill: "#F0D53A"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.76 49.01l-1.1-1.02-1.04 1.12c-6.9-6.03-18.06-12.39-31.7-17.89l.55-1.4-1.4-.55a204.96 204.96 0 00-28.5-8.88l-1.46-.35-.34 1.47c-14.35-3.22-27.15-4.33-36.25-3.3l-.22-1.5-1.49.21c-3.48.51-6.47 1.37-8.78 2.63-2.32 1.26-4.06 3-4.77 5.27-.7 2.28-.27 4.7.92 7.05 1.19 2.35 3.17 4.76 5.74 7.15l1.1 1.03 1.04-1.12c6.9 6.02 18.06 12.39 31.7 17.88l-.55 1.4 1.4.55a204.9 204.9 0 0028.5 8.89l1.46.34.35-1.47c14.34 3.23 27.14 4.33 36.24 3.3l.22 1.51 1.49-.22c3.48-.5 6.47-1.36 8.78-2.62 2.32-1.26 4.06-3 4.77-5.28.7-2.28.27-4.69-.92-7.05-1.19-2.35-3.17-4.75-5.74-7.15z",
  stroke: "#F0D53A",
  strokeWidth: 3,
  strokeMiterlimit: 2.37,
  strokeLinecap: "square",
  strokeDasharray: "30 40"
});

var SvgSpaceOctopus = function SvgSpaceOctopus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 233,
    height: 262,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpaceOctopus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/space-octopus.cfeea4e5.svg";
export { ForwardRef as ReactComponent };